import { render, staticRenderFns } from "./table.vue?vue&type=template&id=5b86cbfe&scoped=true&"
var script = {}
import style0 from "./table.vue?vue&type=style&index=0&id=5b86cbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86cbfe",
  null
  
)

export default component.exports